import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import { api } from '../lib/api'
import DocumentShell from '../features/documents/DocumentShell'
import DispatchSheetView from '../features/documents/DispatchSheetView'
import { formatDate, shortId } from '../features/documents/documentFormatters'

function unwrap<T>(value: any): T {
  const payload = value?.data ?? value
  return payload?.load ?? payload?.job ?? payload?.invoice ?? payload
}

export default function DispatchSheetPage() {
  const { jobId } = useParams<{ jobId: string }>()

  const { data: job } = useQuery({
    queryKey: ['document-pack-job', jobId],
    queryFn: async () => unwrap(await api.jobs.get(jobId!)),
    enabled: !!jobId,
  })

  const { data: load } = useQuery({
    queryKey: ['document-pack-job-load', job?.loadId],
    queryFn: async () => unwrap(await api.loads.get(job!.loadId)),
    enabled: !!job?.loadId,
  })

  const { data: invoices = [] } = useQuery({
    queryKey: ['document-pack-job-invoices', job?.loadId],
    queryFn: async () => (await api.invoices.list({ jobId: jobId! })).data,
    enabled: !!jobId,
  })

  if (!jobId) {
    return <div className="container mx-auto p-6 text-red-600">Job ID is missing.</div>
  }

  if (!job) {
    return <div className="container mx-auto p-6 text-red-600">Job not found.</div>
  }

  const invoice = invoices[0]
  const jobLabel = job.job_number ?? job.jobNumber ?? shortId(job.id)

  return (
    <DocumentShell
      title="Dispatch Sheet"
      subtitle={`Order ${jobLabel}`}
      meta={[
        { label: 'Order', value: jobLabel },
        { label: 'Dispatch Date', value: formatDate(job.assignedAt ?? load?.createdAt ?? load?.created_at) },
        { label: 'Vehicles', value: Array.isArray(load?.vehicles) ? String(load.vehicles.length) : '0' },
        { label: 'Status', value: job.status ?? 'TBD' },
      ]}
      actions={
        <>
          {load?.id && <Link to={`/loads/${load.id}/rate-confirmation`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Rate Confirmation</Link>}
          <Link to={`/jobs/${jobId}/bol`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">BOL</Link>
          <Link to={`/jobs/${jobId}/pod`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">POD</Link>
          <Link to={`/jobs/${jobId}/trailer`} className="rounded border border-slate-400 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Trailer Layout</Link>
        </>
      }
    >
      <DispatchSheetView load={load ?? job} job={job} invoice={invoice} />
    </DocumentShell>
  )
}
